<template>
    <div class="container">
        <header
            class="header-static"
        >
            <a
                class="open-modal close-button"
                @click="$store.dispatch('policy/confirmLeaveDetailsPage')"
            >
                <span
                    class="icon-cross"
                />
            </a>
        </header>
    </div>
</template>

<script>
export default {
    name: 'PolicyHeader'
};
</script>
